// ** React Imports
import { useState, useEffect, ChangeEvent } from 'react'

// ** MUI Imports
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import Select, { SelectChangeEvent } from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import Button from '@mui/material/Button'

// ** Custom Avatar Component
import CustomAvatar from 'src/@core/components/mui/avatar'

import { RootState } from 'src/store'
import { useSelector } from 'react-redux'
import axios from '../../../../services/ApiService'
import { ChannelType, channelDefault } from 'src/types/apps/channelTypes'

import CircularProgress from '@mui/material/CircularProgress';

interface TabChannelSelection {
    medium: number,
    channelType: number
    setChannels: (arg0: ChannelType[]) => void
    channels: ChannelType[]
    existingChannels : any[]
}

const TabChannelSelection = (props: TabChannelSelection) => {
    const { medium, channelType, setChannels, channels, existingChannels } = props;
    const store = useSelector((state: RootState) => state.lookup)
    const [channelsApiData, setChannelsApiData] = useState<ChannelType[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [selectedChannelIds, setSelectedChannelIds] = useState<string[]>(
        (channels ?? [])
            .map(p => p?.channelId?.toString())
            .filter((x): x is string => !!x)
    );
    const [discordGuilds, setDiscordGuilds] = useState<any[]>([])
    const [selectedGuildId, setSelectedGuildId] = useState<string>('')
    const [discordLoadError, setDiscordLoadError] = useState<string>('')

    const accesstoken = store.data.userAccessToken;

    const isSelectedChannelType = (name: string): boolean => {
        let selectedChannelType = store.data.channelTypes.filter(p => p.name == name && p.mediumId == medium)[0];
        return !!selectedChannelType && channelType == selectedChannelType.id;
    }

    useEffect(() => {
        async function fetchChannels() {
            if (isSelectedChannelType("Page") == true)
            {
                setLoading(true);
                //TODO|SMMP : Place these urls in global constants file
                const response = await axios.get('channel/GetFacebookPages');//'https://graph.facebook.com/v15.0/me/accounts?fields=fields=id,name,category,link,about,general_info,is_published,is_unclaimed,can_checkin,can_post,engagement,fan_count,is_webhooks_subscribed,location,new_like_count,overall_star_rating,talking_about_count,unread_message_count,unread_notif_count,unseen_message_count,were_here_count,category_list,featured_video,has_transitioned_to_new_page_experience,hours,parent_page,start_info,verification_status&access_token=' + accesstoken)
                if (response.data) {
                    console.log("Response from Channels data: ", response.data);
                    let channelsData = [];
                    if (existingChannels && existingChannels.length) {
                        channelsData = response.data.filter((value: any) => !(existingChannels.map(s => s.channelId).includes(value.id)));
                    }
                    else {
                        channelsData = response.data;
                    }
                    setChannelsApiData(channelsData);
                }
                setLoading(false);
            }
            else if (isSelectedChannelType("Group") == true)
            {
                setLoading(true);
                const response = await axios.get('https://graph.facebook.com/v15.0/me/groups?fields=administrator,unread,cover,description,icon,id,member_count,name,privacy,purpose,picture,videos&format=json&access_token=' + accesstoken)
                if (response.data) {
                    let channelsData = [];
                    if (existingChannels && existingChannels.length) {
                        channelsData = response.data.filter((value: any) => !(existingChannels.map(s => s.channelId).includes(value.id)));
                    }
                    else {
                        channelsData = response.data;
                    }
                    setChannelsApiData(channelsData);
                }
                setLoading(false);
            }
            else if (isSelectedChannelType("YoutubeChannel") == true) {
                setLoading(true);
                const response = await axios.get('channel/GetYoutubeChannelsList')
                if (response.data) {
                    let channelsData = [];
                    if (existingChannels && existingChannels.length) {
                        channelsData = response.data.filter((value: any) => !(existingChannels.map(s => s.channelId).includes(value.channelId)));
                    }
                    else {
                        channelsData = response.data;
                    }
                    setChannelsApiData(channelsData);
                }
                setLoading(false);
            }
            else if (isSelectedChannelType("PinterestBoard") == true) {
                setLoading(true);
                const response = await axios.get('channel/GetBoards')
                //console.log("Response: ", response.data);

                if (response.data) {
                    let channelsData = [];
                    if (existingChannels && existingChannels.length) {
                        channelsData = response.data.filter((value: any) => !(existingChannels.map(s => s.channelId).includes(value.channelId)));
                    }
                    else {
                        channelsData = response.data;
                    }
                    setChannelsApiData(channelsData);
                }
                setLoading(false);
            }
            else if (isSelectedChannelType("InstragramBusinessAccount") == true) {
                setLoading(true);
                const response = await axios.get('channel/GetInstagramBusinessUserAccounts');
                if (response.data) {
                    let channelsData = [];
                    if (existingChannels && existingChannels.length) {
                        channelsData = response.data.filter((value: any) => !(existingChannels.map(s => s.channelId).includes(value.id)));
                    }
                    else {
                        channelsData = response.data;
                    }
                    setChannelsApiData(channelsData);
                }
                setLoading(false);
            }
            else if (isSelectedChannelType("TikTokCreatorAccount") == true) {
                setLoading(true);
                const response = await axios.get('channel/GetTikTokCreatorAccounts');
                if (response.data) {
                    //console.log('TikTok accounts:', response.data);
                    let channelsData = [];
                    if (existingChannels && existingChannels.length) {
                        channelsData = response.data.filter((value: any) => !(existingChannels.map(s => s.channelId).includes(value.id)));
                    }
                    else {
                        channelsData = response.data;
                    }
                    setChannelsApiData(channelsData);
                }
                setLoading(false);
            }
            else if (isSelectedChannelType("ThreadsAccount") == true) {
                setLoading(true);
                const response = await axios.get('channel/threads/accounts');

                if (response.data) {
                    const normalized = (response.data as any[]).map(t => ({
                        channelId: String(t.id),   
                        id: String(t.id),          
                        name: t.username ? `@${t.username}` : String(t.id),   
                        profileImageUrl: t.pictureUrl ?? undefined,           
                        category: 'Threads'
                    }));

                    let channelsData: any[] = [];
                    if (existingChannels && existingChannels.length) {
                        const existingIds = existingChannels.map(s => s.channelId?.toString());
                        channelsData = normalized.filter(v => !existingIds.includes(v.channelId));
                    } else {
                        channelsData = normalized;
                    }
                    setChannelsApiData(channelsData);
                }
                setLoading(false);
            }
            else if (isSelectedChannelType("LinkedInAccount") == true) {
                setLoading(true);
                const response = await axios.get('channel/linkedin/accounts');

                if (response.data) {
                    const normalized = (response.data as any[]).map(t => {
                        const primaryName =
                            t.displayName || t.name || (t.username ? `@${t.username}` : undefined) || String(t.id);

                        return {
                            channelId: String(t.id),
                            id: String(t.id),
                            name: primaryName, 
                            profileImageUrl: t.pictureUrl ?? undefined,
                            category: 'LinkedIn'
                        };
                    });

                    let channelsData: any[] = [];
                    if (existingChannels && existingChannels.length) {
                        const existingIds = existingChannels.map(s => s.channelId?.toString());
                        channelsData = normalized.filter(v => !existingIds.includes(v.channelId));
                    } else {
                        channelsData = normalized;
                    }
                    setChannelsApiData(channelsData);
                }
                setLoading(false);
            }
            else if (isSelectedChannelType("RedditAccount") == true) {
                setLoading(true);
                const response = await axios.get('channel/reddit/accounts');

                if (response.data) {
                    const normalized = (response.data as any[]).map(t => {
                        const primaryName =
                            t.displayName || t.name || (t.username ? `@${t.username}` : undefined) || String(t.id);

                        return {
                            channelId: String(t.id),
                            id: String(t.id),
                            name: primaryName,
                            profileImageUrl: t.pictureUrl ?? undefined,
                            category: 'Reddit'
                        };
                    });

                    let channelsData: any[] = [];
                    if (existingChannels && existingChannels.length) {
                        const existingIds = existingChannels.map(s => s.channelId?.toString());
                        channelsData = normalized.filter(v => !existingIds.includes(v.channelId));
                    } else {
                        channelsData = normalized;
                    }
                    setChannelsApiData(channelsData);
                }
                setLoading(false);
            }
            else if (isSelectedChannelType("XAccount") == true) {
                setLoading(true);
                const response = await axios.get('channel/X/accounts');

                if (response.data) {
                    const normalized = (response.data as any[]).map(t => {
                        const primaryName =
                            t.displayName || t.name || (t.username ? `@${t.username}` : undefined) || String(t.id);

                        return {
                            channelId: String(t.id),
                            id: String(t.id),
                            name: primaryName,
                            profileImageUrl: t.pictureUrl ?? undefined,
                            category: 'X'
                        };
                    });

                    let channelsData: any[] = [];
                    if (existingChannels && existingChannels.length) {
                        const existingIds = existingChannels.map(s => s.channelId?.toString());
                        channelsData = normalized.filter(v => !existingIds.includes(v.channelId));
                    } else {
                        channelsData = normalized;
                    }
                    setChannelsApiData(channelsData);
                }
                setLoading(false);
            }
            else if (isSelectedChannelType("DiscordAccount") == true) { // discord branch is different from other branches.
                setLoading(true)
                setDiscordLoadError('')
                try {
                    const g = await axios.get('channel/GetDiscordGuilds')
                    const guilds = Array.isArray(g.data) ? g.data : []
                    setDiscordGuilds(guilds)

                    const existingGuildIds = new Set((existingChannels ?? []).map(s => String(s.channelId)))
                    const firstGuildId = guilds.find(x => !existingGuildIds.has(String(x.id)))?.id || guilds[0]?.id || ''

                    setSelectedGuildId(prev => (prev && guilds.some(x => String(x.id) === String(prev))) ? prev : String(firstGuildId))
                    setChannelsApiData([])
                } catch (e: any) {
                    setDiscordGuilds([])
                    setSelectedGuildId('')
                    setChannelsApiData([])
                    setDiscordLoadError('Failed to load Discord servers.')
                } finally {
                    setLoading(false)
                }
            }

        }
        fetchChannels();
    }, [medium, channelType]);

    useEffect(() => {
        async function fetchDiscordGuildChannels() {
            if (!isSelectedChannelType("DiscordAccount")) return
            if (!selectedGuildId) return

            setLoading(true)
            setDiscordLoadError('')

            try {
                const res = await axios.get('channel/discord/channels', { params: { guildId: selectedGuildId } })
                const rows = Array.isArray(res.data) ? res.data : []

                const normalized = rows.map((t: any) => {
                    const guildName = t.guildName || discordGuilds.find(g => String(g.id) === String(t.guildId))?.name || 'Discord'
                    const iconUrl = t.iconUrl || discordGuilds.find(g => String(g.id) === String(t.guildId))?.iconUrl

                    return {
                        channelId: String(t.id),
                        id: String(t.id),
                        name: t.name ? `#${t.name}` : String(t.id),
                        profileImageUrl: iconUrl ?? undefined,
                        category: "Discord - Server: " + guildName
                    }
                })

                const existingIds = new Set((existingChannels ?? []).map(s => String(s.channelId)))
                const filtered = normalized.filter((x: any) => !existingIds.has(String(x.channelId)))

                setChannelsApiData(filtered as any)
            } catch (e: any) {
                setChannelsApiData([])
                setDiscordLoadError('Failed to load channels for this server. Make sure the bot is added to this server.')
            } finally {
                setLoading(false)
            }
        }

        fetchDiscordGuildChannels()
    }, [selectedGuildId, medium, channelType])

    const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

    const toggleDiscordChannel = (ch: any, checked: boolean) => { // for discord to multi select channels for addition
        const key = String(ch?.channelId ?? ch?.id ?? '')
        if (!key) return

        // remove the default/empty placeholder (often channelDefault[0])
        const current = (channels ?? []).filter(c => !!c?.channelId)

        const next = checked
            ? (current.some(c => String(c.channelId) === key)
                ? current
                : [...current, { ...ch, channelId: key, id: 0 }])
            : current.filter(c => String(c.channelId) !== key)

        setChannels(next.length ? (next as any) : (channelDefault as any))
        setSelectedChannelIds(next.map(c => String(c.channelId)))
    }

    return (
        <Box>
            {isSelectedChannelType("DiscordAccount") && (
                <Box sx={{ mb: 3, display: 'flex', gap: 2, alignItems: 'center' }}>
                    <FormControl size="small" sx={{ minWidth: 260 }}>
                        <InputLabel id="discord-guild-label">Discord Server</InputLabel>
                        <Select
                            labelId="discord-guild-label"
                            label="Discord Server"
                            value={selectedGuildId}
                            onChange={(e: SelectChangeEvent) => setSelectedGuildId(String(e.target.value))}
                        >
                            {discordGuilds.map(g => (
                                <MenuItem key={String(g.id)} value={String(g.id)}>
                                    {g.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <Button
                        variant="outlined"
                        disabled={!selectedGuildId}
                        onClick={async () => {
                            const r = await axios.get('channel/GetDiscordBotInviteUrl', {
                                params: { guildId: selectedGuildId }
                            });

                            const url = r?.data?.url;
                            if (url) window.open(url, '_blank');
                        }}
                    >
                        Invite Bot
                    </Button>
                </Box>
            )}

            <Box sx={{ mb: 8, maxHeight: "380px", overflowY: "auto" }}>
                {!loading && !!discordLoadError && (
                    <Box sx={{ mb: 2 }}>
                        <Typography variant="body2" sx={{ color: 'error.main' }}>
                            {discordLoadError}
                        </Typography>
                    </Box>
                )}

                {
                    !loading && channelsApiData != null &&
                    channelsApiData.map((ch : any) => {
                        return <Box
                            sx={{ mb: 6, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
                        >

                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <CustomAvatar skin='light' color='info' variant='rounded' sx={{ mr: 3, width: 48, height: 48 }}>
                                    {(isSelectedChannelType("Page")
                                        || isSelectedChannelType("YoutubeChannel")
                                        || isSelectedChannelType("PinterestBoard")
                                        || isSelectedChannelType("InstragramBusinessAccount")
                                        || isSelectedChannelType("TikTokCreatorAccount")
                                        || isSelectedChannelType("ThreadsAccount"))
                                        || isSelectedChannelType("LinkedInAccount")
                                        || isSelectedChannelType("RedditAccount")
                                        || isSelectedChannelType("XAccount")
                                        || isSelectedChannelType("DiscordAccount")
                                        && (
                                            <img src={ch.profileImageUrl} height="48" width="48" />
                                        )}

                                    {(
                                        !isSelectedChannelType("YoutubeChannel") &&
                                        !isSelectedChannelType("PinterestBoard") &&
                                        !isSelectedChannelType("InstragramBusinessAccount") &&
                                        !isSelectedChannelType("TikTokCreatorAccount") &&
                                        !isSelectedChannelType("Page") &&
                                        !isSelectedChannelType("ThreadsAccount") &&
                                        !isSelectedChannelType("LinkedInAccount") && 
                                        !isSelectedChannelType("RedditAccount") && 
                                        !isSelectedChannelType("XAccount") &&
                                        !isSelectedChannelType("DiscordAccount") 
                                        )
                                        &&
                                        (
                                            <img src={`https://graph.facebook.com/v15.0/${ch.id}/picture?height=40&width=40&access_token=${accesstoken}`} />
                                        )}
                                </CustomAvatar>
                                <Box>
                                    <Typography sx={{ color: 'text.secondary' }}>{ch.name}</Typography>
                                    <Typography variant='caption' sx={{ color: 'text.disabled' }}>
                                        {ch.category }
                                    </Typography>
                                </Box>
                            </Box>
                            {
                                (isSelectedChannelType("Page")) && //facebook page
                                <Checkbox {...label} checked={channels.some((s) => s.channelId == ch.channelId)} onChange={(e, c) => {
                                    if (c) {
                                        let chIds = selectedChannelIds ? [...selectedChannelIds, ch.channelId.toString()] : [ch.channelId.toString()];
                                        setSelectedChannelIds(chIds);
                                        setChannels(channelsApiData.filter((chn) => chIds.some((s) => s == chn.channelId.toString()))
                                            .map((o) => ({ ...o, channelId: o.channelId, id: 0 })))
                                    }
                                    else {
                                        if (selectedChannelIds) {
                                            let chIds = selectedChannelIds.filter(p => p != ch.id.toString())
                                            setSelectedChannelIds(chIds);
                                            setChannels(channelsApiData.filter((chn) => chIds.some((s) => s == chn.id.toString()))
                                                .map((o) => ({ ...o, channelId: o.channelId, id: 0 })))
                                        }
                                    }
                                }
                                } />
                            }
                            {
                                (isSelectedChannelType("YoutubeChannel")) && 
                                <Checkbox {...label} checked={channels.some((s) => s.channelId == ch.channelId)} onChange={(e, c) => {
                                    if (c) {
                                        let chIds = selectedChannelIds ? [...selectedChannelIds, ch.id.toString()] : [ch.id.toString()];
                                        setSelectedChannelIds(chIds);
                                        setChannels(channelsApiData.filter((chn) => chIds.some((s) => s == chn.id.toString()))
                                            .map((o) => ({ ...o, channelId: o.channelId , id: 0 })))
                                    }
                                    else {
                                        if (selectedChannelIds) {
                                            let chIds = selectedChannelIds.filter(p => p != ch.id.toString())
                                            setSelectedChannelIds(chIds);
                                            setChannels(channelsApiData.filter((chn) => chIds.some((s) => s == chn.id.toString()))
                                                .map((o) => ({ ...o, channelId: o.channelId, id: 0 })))
                                        }
                                    }
                                }
                                } />
                            }
                            {
                                (isSelectedChannelType("PinterestBoard")) &&
                                <Checkbox {...label} checked={channels.some((s) => s.channelId == ch.channelId)} onChange={(e, c) => {
                                    if (c) {
                                        let chIds = selectedChannelIds ? [...selectedChannelIds, ch.channelId.toString()] : [ch.channelId.toString()];
                                        setSelectedChannelIds(chIds);
                                        setChannels(channelsApiData.filter((chn) => chIds.some((s) => s == chn.channelId.toString()))
                                            .map((o) => ({ ...o, channelId: o.channelId, id: 0 })))
                                    }
                                    else {
                                        if (selectedChannelIds) {
                                            let chIds = selectedChannelIds.filter(p => p != ch.id.toString())
                                            setSelectedChannelIds(chIds);
                                            setChannels(channelsApiData.filter((chn) => chIds.some((s) => s == chn.id.toString()))
                                                .map((o) => ({ ...o, channelId: o.channelId, id: 0 })))
                                        }
                                    }
                                }
                                } />
                            }
                            {
                                (isSelectedChannelType("InstragramBusinessAccount")) &&
                                <Checkbox {...label} checked={channels.some((s) => s.channelId == ch.channelId)} onChange={(e, c) => {
                                    if (c) {
                                        let chIds = selectedChannelIds ? [...selectedChannelIds, ch.channelId.toString()] : [ch.channelId.toString()];
                                        setSelectedChannelIds(chIds);
                                        setChannels(channelsApiData.filter((chn) => chIds.some((s) => s == chn.channelId.toString()))
                                            .map((o) => ({ ...o, channelId: o.channelId, id: 0 })))
                                    }
                                    else {
                                        if (selectedChannelIds) {
                                            let chIds = selectedChannelIds.filter(p => p != ch.id.toString())
                                            setSelectedChannelIds(chIds);
                                            setChannels(channelsApiData.filter((chn) => chIds.some((s) => s == chn.id.toString()))
                                                .map((o) => ({ ...o, channelId: o.channelId, id: 0 })))
                                        }
                                    }
                                }
                                } />
                            }
                            {
                                (isSelectedChannelType("TikTokCreatorAccount")) &&
                                <Checkbox {...label} checked={channels.some((s) => s.channelId == ch.channelId)} onChange={(e, c) => {
                                    if (c) {
                                        let chIds = selectedChannelIds ? [...selectedChannelIds, ch.channelId.toString()] : [ch.channelId.toString()];
                                        setSelectedChannelIds(chIds);
                                        setChannels(channelsApiData.filter((chn) => chIds.some((s) => s == chn.channelId.toString()))
                                            .map((o) => ({ ...o, channelId: o.channelId, id: 0 })))
                                    }
                                    else {
                                        if (selectedChannelIds) {
                                            let chIds = selectedChannelIds.filter(p => p != ch.id.toString())
                                            setSelectedChannelIds(chIds);
                                            setChannels(channelsApiData.filter((chn) => chIds.some((s) => s == chn.id.toString()))
                                                .map((o) => ({ ...o, channelId: o.channelId, id: 0 })))
                                        }
                                    }
                                }
                                } />
                            }
                            {(isSelectedChannelType("ThreadsAccount")) &&
                                <Checkbox
                                    {...label}
                                    checked={channels.some(s => s.channelId == ch.channelId)}
                                    onChange={(e, c) => {
                                        if (c) {
                                            const chIds = selectedChannelIds
                                                ? [...selectedChannelIds, ch.channelId.toString()]
                                                : [ch.channelId.toString()];
                                            setSelectedChannelIds(chIds);
                                            setChannels(
                                                channelsApiData
                                                    .filter(chn => chIds.some(s => s == chn.channelId.toString()))
                                                    .map(o => ({ ...o, channelId: o.channelId, id: 0 }))
                                            );
                                        } else {
                                            if (selectedChannelIds) {
                                                const chIds = selectedChannelIds.filter(p => p != ch.channelId.toString());
                                                setSelectedChannelIds(chIds);
                                                setChannels(
                                                    channelsApiData
                                                        .filter(chn => chIds.some(s => s == chn.channelId.toString()))
                                                        .map(o => ({ ...o, channelId: o.channelId, id: 0 }))
                                                );
                                            }
                                        }
                                    }}
                                />
                            }
                            {(isSelectedChannelType("LinkedInAccount")) &&
                                <Checkbox
                                    {...label}
                                    checked={channels.some(s => s.channelId == ch.channelId)}
                                    onChange={(e, c) => {
                                        if (c) {
                                            const chIds = selectedChannelIds
                                                ? [...selectedChannelIds, ch.channelId.toString()]
                                                : [ch.channelId.toString()];
                                            setSelectedChannelIds(chIds);
                                            setChannels(
                                                channelsApiData
                                                    .filter(chn => chIds.some(s => s == chn.channelId.toString()))
                                                    .map(o => ({ ...o, channelId: o.channelId, id: 0 }))
                                            );
                                        } else {
                                            if (selectedChannelIds) {
                                                const chIds = selectedChannelIds.filter(p => p != ch.channelId.toString());
                                                setSelectedChannelIds(chIds);
                                                setChannels(
                                                    channelsApiData
                                                        .filter(chn => chIds.some(s => s == chn.channelId.toString()))
                                                        .map(o => ({ ...o, channelId: o.channelId, id: 0 }))
                                                );
                                            }
                                        }
                                    }}
                                />
                            }
                            {(isSelectedChannelType("RedditAccount")) &&
                                <Checkbox
                                    {...label}
                                    checked={channels.some(s => s.channelId == ch.channelId)}
                                    onChange={(e, c) => {
                                        if (c) {
                                            const chIds = selectedChannelIds
                                                ? [...selectedChannelIds, ch.channelId.toString()]
                                                : [ch.channelId.toString()];
                                            setSelectedChannelIds(chIds);
                                            setChannels(
                                                channelsApiData
                                                    .filter(chn => chIds.some(s => s == chn.channelId.toString()))
                                                    .map(o => ({ ...o, channelId: o.channelId, id: 0 }))
                                            );
                                        } else {
                                            if (selectedChannelIds) {
                                                const chIds = selectedChannelIds.filter(p => p != ch.channelId.toString());
                                                setSelectedChannelIds(chIds);
                                                setChannels(
                                                    channelsApiData
                                                        .filter(chn => chIds.some(s => s == chn.channelId.toString()))
                                                        .map(o => ({ ...o, channelId: o.channelId, id: 0 }))
                                                );
                                            }
                                        }
                                    }}
                                />
                            }
                            {(isSelectedChannelType("XAccount")) &&
                                <Checkbox
                                    {...label}
                                    checked={channels.some(s => s.channelId == ch.channelId)}
                                    onChange={(e, c) => {
                                        if (c) {
                                            const chIds = selectedChannelIds
                                                ? [...selectedChannelIds, ch.channelId.toString()]
                                                : [ch.channelId.toString()];
                                            setSelectedChannelIds(chIds);
                                            setChannels(
                                                channelsApiData
                                                    .filter(chn => chIds.some(s => s == chn.channelId.toString()))
                                                    .map(o => ({ ...o, channelId: o.channelId, id: 0 }))
                                            );
                                        } else {
                                            if (selectedChannelIds) {
                                                const chIds = selectedChannelIds.filter(p => p != ch.channelId.toString());
                                                setSelectedChannelIds(chIds);
                                                setChannels(
                                                    channelsApiData
                                                        .filter(chn => chIds.some(s => s == chn.channelId.toString()))
                                                        .map(o => ({ ...o, channelId: o.channelId, id: 0 }))
                                                );
                                            }
                                        }
                                    }}
                                />
                            }
                            {(isSelectedChannelType("DiscordAccount")) &&
                                <Checkbox
                                    {...label}
                                    checked={channels.some(s => String(s.channelId) === String(ch.channelId))}
                                    onChange={(e, c) => toggleDiscordChannel(ch, c)}
                                />
                            }
                            {
                                !(isSelectedChannelType("Page")
                                || isSelectedChannelType("YoutubeChannel")
                                || isSelectedChannelType("PinterestBoard")
                                || isSelectedChannelType("InstragramBusinessAccount")
                                || isSelectedChannelType("TikTokCreatorAccount"))
                                || isSelectedChannelType("ThreadsAccount")
                                || isSelectedChannelType("LinkedInAccount")
                                || isSelectedChannelType("RedditAccount")
                                || isSelectedChannelType("XAccount")
                                || isSelectedChannelType("DiscordAccount")
                                && <Checkbox
                                    {...label}
                                    checked={channels.some(s => s.channelId === String(ch.id))}
                                    onChange={(e, c) => {
                                        const id = String(ch.id);
                                        if (c) {
                                            const chIds = [...selectedChannelIds, id];
                                            setSelectedChannelIds(chIds);
                                            setChannels(
                                                channelsApiData
                                                    .filter(chn => chIds.includes(String(chn.id)))
                                                    .map(o => ({ ...o, channelId: String(o.id), id: 0 }))
                                            );
                                        } else {
                                            const chIds = selectedChannelIds.filter(p => p !== id);
                                            setSelectedChannelIds(chIds);
                                            setChannels(
                                                channelsApiData
                                                    .filter(chn => chIds.includes(String(chn.id)))
                                                    .map(o => ({ ...o, channelId: String(o.id), id: 0 }))
                                            );
                                        }
                                    }}
                                />
                            }

                        </Box>
                    })
                }
                {!loading && !channelsApiData.length && (
                    <Box
                        sx={{
                            textAlign: 'center',
                            padding: 3,
                            backgroundColor: 'background.paper',
                            borderRadius: 2,
                            boxShadow: 1,
                            marginTop: 2,
                            color: 'text.secondary',
                        }}
                    >
                        <Typography variant="body1" sx={{ fontWeight: 'medium', marginBottom: 1 }}>
                            No channels found.
                        </Typography>
                        <Typography variant="body2">
                            Please add a social media channel to proceed.
                        </Typography>
                    </Box>
                )}

                {
                    loading && <div style={{textAlign : "center"}}><CircularProgress /></div>
                }
            </Box>
        </Box>
    )
}

export default TabChannelSelection
